import { init, browserTracingIntegration, replayIntegration } from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./app";
import { beforeAddRecordingEvent, beforeBreadcrumb, beforeSend, beforeSendTransaction } from "./sentry-scrub";

init({
  dsn: "https://3796c806923fcfcfda1b326bbc282545@o4506649005260800.ingest.us.sentry.io/4506649007292416",
  integrations: [browserTracingIntegration(), replayIntegration({ beforeAddRecordingEvent })],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  beforeSend,
  beforeSendTransaction,
  beforeBreadcrumb,
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
